<template>
  <v-row dense>
    <v-col>
      <v-card>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Fabricante
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ prosthesis.manufacturer.name }}
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Tipo
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ prosthesis.prosthesisType.name }}
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Modelo
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ prosthesis.name }}
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Dioptria
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ intraoperativeProsthesis.diopter }}
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Lote
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ intraoperativeProsthesis.batch }}
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="auto">
              <authorization
                permissionKey="attendance_surgery"
                can="save"
                v-slot:default="{ authorization }"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      :attrs="attrs"
                      v-on="on"
                      v-if="authorization && allowEdit"
                      @click="editSurgeryIndicationProsthesis"
                      :disabled="disabled"
                    >
                      <v-icon>eva-edit-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Editar
                  </span>
                </v-tooltip>
              </authorization>

              <authorization
                permissionKey="attendance_surgery"
                can="save"
                v-slot:default="{ authorization }"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      icon
                      :attrs="attrs"
                      v-on="on"
                      @click="deleteSurgeryIndicationProsthesis"
                      v-if="authorization && allowDelete"
                      :disabled="disabled"
                    >
                      <v-icon>eva-trash-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Excluir
                  </span>
                </v-tooltip>
              </authorization>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold">
                  Observações
                </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ intraoperativeProsthesis.observation }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row dense>
            <v-col class="font-weight-bold">
              Anexos
            </v-col>

            <v-spacer />

            <v-col cols="auto">
              <v-btn icon small @click="showAttachment = !showAttachment">
                <v-icon v-if="showAttachment">eva-chevron-up-outline</v-icon>
                <v-icon v-else>eva-chevron-down-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-row dense v-show="showAttachment">
            <v-col>
              <FileUpload
                ownerType="Surgery::Intraoperative::Prosthesis"
                :ownerId="intraoperativeProsthesis.id"
                :disabled="disabled"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "ProsthesisListItem",
    props: {
      surgeryIndication: Object,
      intraoperativeProsthesis: Object,
      editProsthesis: {
        type: Function,
        default: () => {},
      },
      refreshProstheses: {
        type: Function,
        default: () => {},
      },
      allowDelete: Boolean,
      allowEdit: Boolean,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showAttachment: false,
      };
    },
    computed: {
      prosthesis() {
        return this.intraoperativeProsthesis.prosthesis;
      },
    },
    methods: {
      deleteSurgeryIndicationProsthesis() {
        if (this.disabled) return;

        return this.apolloMutate({
          mutation: require("@/graphql/surgery/delete_prosthesis_surgery_intraoperative.gql"),
          variables: {
            surgeryIntraoperativeProsthesisId: this.intraoperativeProsthesis.id,
          },
        }).then(() => {
          this.refreshProstheses();
        });
      },
      editSurgeryIndicationProsthesis() {
        this.editProsthesis(this.intraoperativeProsthesis);
      },
    },
  };
</script>

<style lang="sass" scoped></style>
